module.exports = __webpack_public_path__ + "img/support.740c263d.png";